import React from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";

const FRAME_DATA = {
  imgSrc: "/static/img/solutions/consumption.png",
  imgAlt: "Um medidor inteligente de energia",
  title: "Monitorar consumo de energia",
  buttonText: "Ir para a Loja Virtual",
  cardImgSrc:
    "https://www.enermatch.com/wp-content/uploads/2024/11/foto-principal-smartmeter.jpg",
};

export const AutomateConsumerMonitoring = ({ history }) => {
  const handleClick = () => {
    history.push("/frames/store");
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleClick}>
      <BlockStandard hideDivider>
        <Typography variant="h2">Excelente iniciativa!</Typography>
        <Typography>
          O primeiro passo para reduzir o consumo de energia é identificar as
          possíveis fontes de desperdício.
        </Typography>
        <Typography>
          Adquira medidores inteligentes para acompanhar o consumo de energia
          geral e de sub-circuitos importantes do edifício 24h por dia.
        </Typography>
        <Typography>
          Fique atento para adquirir os medidores que possuem transformadores de
          corrente na amperagem e tamanhos de furo de acordo com os circuitos
          que você medirá!
        </Typography>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Typography variant="h2">Potencial de economia: até 25%</Typography>
        <Card sx={{ display: "flex" }}>
          <CardActionArea sx={{ display: "flex" }} onClick={handleClick}>
            <CardMedia
              sx={{ flex: 1, height: "90%" }}
              image={FRAME_DATA.cardImgSrc}
            />
            <CardContent sx={{ flex: 1 }}>
              <Typography variant="body2">
                Medidor Inteligente Wi-Fi com TCs
              </Typography>
              <Typography>A partir de:</Typography>
              <Typography variant="body2">R$ 149,00</Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </BlockStandard>
    </SolutionsFrame>
  );
};
